module.exports = __webpack_public_path__ + "static/google_cloud-8c699d13ca46649eb2322c96b48828aa.png";